import { Component, input } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import type { RespondTextConfig, RespondTextForm } from '@core/ask-hr-dynamic-forms-types';
import {
  FormErrorDirective,
  FormFieldComponent,
  InputComponent,
  NumericInputComponent,
  TextareaComponent,
} from '@core/user-interface-legacy';

import { RespondFormWrapperComponent } from '../../partials/respond-form-wrapper/respond-form-wrapper.component';

@Component({
  selector: 'input-text-respond',
  imports: [
    RespondFormWrapperComponent,
    ReactiveFormsModule,
    InputComponent,
    TextareaComponent,
    NumericInputComponent,
    FormFieldComponent,
    FormErrorDirective,
  ],
  template: `
    <respond-form-wrapper [answerConfig]="respondConfig()">
      <rt-form-field>
        @switch (respondConfig().kind) {
          @case ('single-line') {
            <rt-input
              [readOnly]="!!respondConfig().disabled"
              [formControl]="respondForm().controls.value"
              [placeholder]="respondConfig().placeholder"
              [rtFormError]="respondConfig().errors || {}"
              (blur)="respondConfig().onBlur?.(respondForm())"
            />
          }
          @case ('multiline') {
            <rt-textarea
              [readOnly]="!!respondConfig().disabled"
              [formControl]="respondForm().controls.value"
              [placeholder]="respondConfig().placeholder"
              [rtFormError]="respondConfig().errors || {}"
              [autoHeight]="true"
              (blur)="respondConfig().onBlur?.(respondForm())"
            />
          }
          @case ('number') {
            <rt-numeric-input
              [readOnly]="!!respondConfig().disabled"
              [formControl]="respondForm().controls.value"
              [placeholder]="respondConfig().placeholder"
              [rtFormError]="respondConfig().errors || {}"
              [disableInvalidStyles]="
                !!respondConfig().disabled || respondForm().controls.value.untouched
              "
              (blur)="respondConfig().onBlur?.(respondForm())"
            />
          }
          @case ('link') {
            <rt-input
              [readOnly]="!!respondConfig().disabled"
              [formControl]="respondForm().controls.value"
              [placeholder]="respondConfig().placeholder"
              [rtFormError]="respondConfig().errors || {}"
              (blur)="respondConfig().onBlur?.(respondForm())"
            />
          }
        }
      </rt-form-field>
    </respond-form-wrapper>
  `,
})
export class RespondTextComponent {
  public respondConfig = input.required<RespondTextConfig>();
  public respondForm = input.required<RespondTextForm>();
}
